import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = " .lsgs-MS4xNC4w--portal-header{display:block;}.lsgs-MS4xNC4w--portal-header-flyout-close{margin:0 auto;padding:0 16px;position:relative;max-width:1680px;}.lsgs-MS4xNC4w--portal-header-flyout-close-link{position:absolute;top:16px;right:16px;}.lsgs-MS4xNC4w--portal-header-top-right{display:flex;align-items:center;}";
var hostClass = "lsgs-MS4xNC4w--portal-header";
styleInject(reactStyles);
collectStyles(reactStyles);

export { hostClass, reactStyles };
